// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-673","col":"styles_col__2tRMv"};